// extracted by mini-css-extract-plugin
export var parcelRow = "_td-0";